import React from 'react'

export const IconStatistics = (props={}) => {
	const { size=20, imgSize=20 } = props
	return <>
		<svg width={`${size}px`} height={`${size}px`} viewBox={`0 0 ${imgSize} ${imgSize}`} stroke="currentColor" fill="currentColor" strokeWidth="0" xmlns="http://www.w3.org/2000/svg">
			<path d="M4.16675 15.8333H5.41675V6.66665H4.16675V15.8333ZM7.63883 15.8333H8.88883V3.33331H7.63883V15.8333ZM11.1113 15.8333H12.3613V9.99998H11.1113V15.8333ZM14.5834 6.66665V15.8333H15.8334V6.66665H14.5834Z" />
		</svg>
	</>
}
